import { ActionReducerMap } from '@ngrx/store';
import { GlobalState } from './global.state';
import { loginReducer } from './auth/auth.reducer';
import { loginAdminReducer } from './auth-admin/auth-admin.reducer';
import { goodModeReducer } from './goodmode/goodmode.reducer';
import { uiReducer } from './ui/ui.reduce';
import { setPasswordReducer } from './set-password/reducer';
import { loginCredentialsReducer } from './login/reducer';
import { loginCodeReducer } from './login-code/reducer';
import { changePasswordReducer } from './change-password/reducer';

// @ts-ignore
export const reducers: ActionReducerMap<GlobalState> = {
  authUserState: loginReducer,
  authAdminState: loginAdminReducer,
  setPasswordState: setPasswordReducer,
  changePasswordState: changePasswordReducer,
  loginCredentialsState: loginCredentialsReducer,
  loginCodeState: loginCodeReducer,
  goodModeState: goodModeReducer,
  uiState: uiReducer,
};
